export const LangText: any = {
    us: {
        priceMsA1: 'Now',
        priceMsB1: 'MSRP',
        soldOut: 'Sold Out',
    },
    de: {
        soldOut: 'Ausverkauft',
    },
    fr: {
        soldOut: 'Épuisé'
    },
    es: {
        soldOut: 'Agotado'
    },
    it: {
        soldOut: 'Esaurito'
    },
    jp: {
        soldOut: '売り切れ'
    },
};
